import gql from 'graphql-tag';

export default gql`
fragment CouponCodeAllData on CouponCode {
    code
    usage_count
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/CouponCodeAllData.ts